import { Component, Input } from '@angular/core';
import { FilesService } from '../../service/files.service';
import { File as FileClass } from '../../model/file';

/**
 * Pills de arquivos reutilizáveis (originados do card de "Minhas revisões").
 * Renderiza um pill por `trackFile`: enviado (nome + ícone de download) ou
 * ausente (nome + ícone "block"). Pareia o arquivo enviado ao trackFile por
 * `file.trackFile.id`.
 *
 * Uso:
 *   <app-file-pills [trackFiles]="trackFiles" [files]="submission.files" align="right">
 *   </app-file-pills>
 */
@Component({
  selector: 'app-file-pills',
  templateUrl: './file-pills.component.html',
  styleUrls: ['./file-pills.component.scss']
})
export class FilePillsComponent {
  constructor(private filesService: FilesService) {}

  /** Baixa PELA API. O `file.url` aponta para a rota da biblioteca de
   *  criptografia, que autentica por cookie de sessão — incompatível com o
   *  token no cabeçalho que esta aplicação usa. Um `<a href>` para lá dava
   *  erro (issue #2376). */
  baixar(file: FileClass): void {
    if (!file) { return; }
    this.filesService.downloadToDisk(file).subscribe(() => {}, () => {});
  }

  // Arquivos esperados (FileRules / trackFiles). Quem chama decide a lista (ex.:
  // filtrar por visibleReviewer, ou todos no admin).
  @Input() trackFiles: any[] = [];
  // Arquivos enviados (File), pareados ao trackFile por `trackFile.id`.
  @Input() files: any[] = [];
  // Alinhamento dos pills no eixo cruzado (esquerda padrão; direita p/ a coluna
  // de arquivos da tabela de submissões e o aside do "Minhas revisões").
  @Input() align: 'left' | 'right' = 'left';

  public findFile(trackFile: any): any | null {
    if (!trackFile || !this.files) {
      return null;
    }
    return this.files.find(file => file?.trackFile?.id === trackFile.id) || null;
  }

  // Ícone (Material Symbols) por extensão do arquivo.
  public getFileMSIcon(file: any): string {
    const name = (file?.name || file?.file || '').toString().toLowerCase();
    const ext = name.split('.').pop() || '';
    switch (ext) {
      case 'pdf':
        return 'picture_as_pdf';
      case 'doc':
      case 'docx':
      case 'odt':
      case 'rtf':
        return 'description';
      case 'zip':
      case 'rar':
      case '7z':
      case 'tar':
      case 'gz':
        return 'folder_zip';
      case 'mp4':
      case 'mpg':
      case 'mov':
      case 'avi':
      case 'mkv':
        return 'movie';
      case 'html':
      case 'htm':
        return 'code';
      case 'ps':
      case 'txt':
        return 'article';
      default:
        return 'attach_file';
    }
  }
}
